import React, { Component } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  AutoLink,
  Autosave,
  Bold,
  Essentials,
  GeneralHtmlSupport,
  Heading,
  Italic,
  Link,
  List,
  Paragraph,
  SourceEditing,
  Style,
  Underline
} from "ckeditor5";
import striptags from "striptags";
import { Element, withStyleguide } from "cw-styleguide-react";
// Copied CSS from node_modules/ckeditor5/dist/ckeditor5.css
import "./WysiwygElement.css";

class WysiwygElement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: this.props.name,
      hasValueChangedViaEditor: false,
    };

    // Generated from https://ckeditor.com/ckeditor-5/builder/
    this.configuration = {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "|",
          "heading",
          "style",
          // "|",
          // "sourceEditing"
        ],
        shouldNotGroupWhenFull: false,
      },
      plugins: [
        AutoLink,
        Autosave,
        Bold,
        Essentials,
        GeneralHtmlSupport,
        Heading,
        Italic,
        Link,
        List,
        Paragraph,
        // SourceEditing,
        Style,
        Underline
      ],
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph",
          },
          {
            model: "heading2",
            view: "h2",
            title: "Heading 2",
            class: "ck-heading_heading2",
          },
          {
            model: "heading3",
            view: "h3",
            title: "Heading 3",
            class: "ck-heading_heading3",
          },
          {
            model: "heading4",
            view: "h4",
            title: "Heading 4",
            class: "ck-heading_heading4",
          },
        ],
      },
      htmlSupport: {
        allow: [
          {
            name: /^.*$/,
            // Set to false to prevent external styles/classes coming from pasted content for #12953.
            // https://ckeditor.com/docs/ckeditor5/latest/api/module_html-support_generalhtmlsupportconfig-GeneralHtmlSupportConfig.html
            styles: false, // default: true
            attributes: false,  // default: true
            classes: false,  // default: true
          }
        ]
      },
      link: {
        // addTargetToExternalLinks: true,
        defaultProtocol: "https://",
        decorators: {
          // toggleDownloadable: {
          //   mode: "manual",
          //   label: "Downloadable",
          //   attributes: {
          //     download: "file",
          //   },
          // },
          toggleOpensNewTab: {
            mode: "manual",
            label: "Open in a new tab",
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          // toggleAriaLabel: {
          //   mode: "manual",
          //   label: "Add aria-label",
          //   attributes: {
          //     "aria-label": ""
          //   },
          // },
        },
      },
      style: {
        definitions: [
          {
            name: "Introduction",
            element: "p",
            classes: ["style", "style--introduction"],
          },
          {
            name: "List Square",
            element: "ul",
            classes: ["style--list-square", "style--list-no-bg"],
          },
          {
            name: "List Tick",
            element: "ul",
            classes: ["style--list-tick", "style--list-no-bg"],
          },
          {
            name: "List Circle",
            element: "ul",
            classes: ["style--list-circle", "style--list-no-bg"],
          },
        ],
      },
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.setState({
        key: this.props.name,
      });
    }

    if (this.props.value !== prevProps.value) {
      // Force remount if provided value was not changed via the editor.
      if (!this.state.hasValueChangedViaEditor) {
        this.setState({
          key: this.props.name + Date.now(),
        });
      }

      this.setState({
        hasValueChangedViaEditor: false,
      });
    } else {
      // Reset changed via editor flag to false in instance where the user types too fast and breaks the value check.
      if (this.state.hasValueChangedViaEditor) {
        this.setState({
          hasValueChangedViaEditor: false,
        });
      }
    }
  }

  handleOnChange(eventInfo, editor) {
    this.setState({
      hasValueChangedViaEditor: true,
    });

    let valid = true;

    // Check if the character count is longer than the maximum length.
    if (this.props.maxLength) {
      const data = editor.data.get();
      const dataStripped = striptags(data);

      if (dataStripped.length > this.props.maxLength) {
        valid = false;
      }
    }

    if (!valid) {
      // Force remount if provided value is not valid.
      this.setState({
        key: this.props.name + Date.now(),
      });
    } else {
      this.props.onChange(editor);
    }
  }

  // handleInstanceReady(e) {
  //   const elements = ["p", "h2", "h3", "h4", "ul", "ol", "li"];

  // Set rules functionality no longer avaialable in CKEditor 5 https://github.com/ckeditor/ckeditor4/issues/4364
  //   elements.forEach((element) => {
  //     e.data.htmlProcessor.htmlWriter.setRules(element, {
  //       indent: false,
  //       breakBeforeOpen: false,
  //       breakAfterOpen: false,
  //       breakBeforeClose: false,
  //       breakAfterClose: false,
  //     });
  //   });
  // }

  render() {
    return (
      <Element type={"wysiwyg"} {...this.props}>
        <div id={this.props.id}>
          {/* CKEditor5 documentation https://ckeditor.com/docs/ckeditor5/latest/getting-started/installation/react/react.html#quick-start */}
          <CKEditor
            key={this.state.key} // Key prop forces rerender to refresh initData
            name={this.props.name}
            editor={ClassicEditor}
            config={this.configuration}
            data={this.props.value}
            disabled={this.props.disabled}
            onChange={this.handleOnChange}
            // onReady={this.handleInstanceReady}
          />
        </div>
      </Element>
    );
  }
}

export default withStyleguide(WysiwygElement);
